import { TLanguage } from 'contexts/app-context/types'
import { forEach, upperFirst } from 'lodash'

import { Report } from '../../../types/YourPersonalData.types'

type GroupedReportsByYearAndMonth = Record<string, Record<string, Report[]>>

export function groupedAndSortedReportsByYearAndMonth(
  reports: Report[],
  language: TLanguage,
): GroupedReportsByYearAndMonth {
  const sortedReports = reports.toSorted(
    (reportA, reportB) => Date.parse(reportB.requestDate) - Date.parse(reportA.requestDate),
  )

  const reportsByYearAndMonth: GroupedReportsByYearAndMonth = {}

  forEach(sortedReports, (report) => {
    const fullYear = formatDate('FULL_YEAR', language, report.requestDate)
    const monthName = upperFirst(formatDate('MONTH_NAME', language, report.requestDate))

    reportsByYearAndMonth[fullYear] ??= {}

    if (reportsByYearAndMonth[fullYear][monthName]) {
      reportsByYearAndMonth[fullYear][monthName] = [
        ...reportsByYearAndMonth[fullYear][monthName],
        report,
      ]
    } else {
      reportsByYearAndMonth[fullYear][monthName] = [report]
    }
  })

  return reportsByYearAndMonth
}

export function formatDate(
  type: 'FULL_YEAR' | 'MONTH_NAME' | 'MONTH_AND_FULL_YEAR' | 'FULL_DATE',
  language: TLanguage,
  date: string,
) {
  if (!type || !language || !date) throw new Error('Date and language are required')

  const dateAsDate = new Date(date)

  // eg: "2020"
  if (type === 'FULL_YEAR')
    return new Intl.DateTimeFormat(language, { year: 'numeric' }).format(dateAsDate)

  // eg: "January"
  if (type === 'MONTH_NAME')
    return new Intl.DateTimeFormat(language, { month: 'long' }).format(dateAsDate)

  // eg: "01/2020"
  if (type === 'MONTH_AND_FULL_YEAR')
    return new Intl.DateTimeFormat(language, { month: '2-digit', year: 'numeric' }).format(
      dateAsDate,
    )

  // eg: "12/20/2020"
  return new Intl.DateTimeFormat(language).format(dateAsDate)
}
